mutation BudgetDelete($input: BudgetDeleteInput!) {
  budgetDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
